export default __webpack_public_path__ + "static/media/SLA.9bcb317f.png";